import { Menu } from "@mui/material";
import Button from "@mui/material/Button";
import { get } from "lodash";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { StyledMenuItem } from "src/components/StyledMenuItem/StyledMenuItem";
import { useLoading } from "src/hooks/useLoading";
import { fetchApplicationById } from "src/store/reducers/applicationBuilder";
import { createApplication } from "src/store/reducers/applications";
import * as S from "../../constants/StringConstants";

interface ApplicationActionsProps {
  application: { id: string };
  handleDelete: (id: string) => void;
}

export const ApplicationActions = ({ application, ...props }: ApplicationActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const { setIsLoading } = useLoading();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleClone = async e => {
    e.stopPropagation();
    handleClose(e);

    try {
      setIsLoading(true);
      const applicationId = application.id;
      if (!applicationId) return;

      const resp: any = await dispatch(fetchApplicationById(+applicationId));
      const applicationToClone = get(resp, "value.data");

      // Clone the application
      const clonedApplication = {
        ...applicationToClone,
        id: undefined, // Remove ID
        applicationAlerts: undefined,
      };

      // Save the cloned application
      const cloneResponse: any = await dispatch(createApplication(clonedApplication));

      if (cloneResponse?.value?.data) {
        // Redirect to new application page
        window.open(`/applications/${cloneResponse.value.data}`);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async e => {
    e.stopPropagation();
    handleClose(e);
    const applicationId = application.id;
    if (!applicationId) return;
    props.handleDelete(applicationId);
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
          <path
            d="M8.25 12.75C8.25 13.1412 8.58579 13.4583 9 13.4583C9.41421 13.4583 9.75 13.1412 9.75 12.75C9.75 12.3588 9.41421 12.0417 9 12.0417C8.58579 12.0417 8.25 12.3588 8.25 12.75Z"
            stroke="#B4B4C4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.25 8.5C8.25 8.8912 8.58579 9.20833 9 9.20833C9.41421 9.20833 9.75 8.8912 9.75 8.5C9.75 8.1088 9.41421 7.79167 9 7.79167C8.58579 7.79167 8.25 8.1088 8.25 8.5Z"
            stroke="#B4B4C4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.25 4.25C8.25 4.6412 8.58579 4.95833 9 4.95833C9.41421 4.95833 9.75 4.6412 9.75 4.25C9.75 3.8588 9.41421 3.54167 9 3.54167C8.58579 3.54167 8.25 3.8588 8.25 4.25Z"
            stroke="#B4B4C4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}>
        <StyledMenuItem onClick={handleClone}>{S.APP_CLONE_BUTTON}</StyledMenuItem>
        <StyledMenuItem onClick={handleDelete}>{S.APP_DELETE_BUTTON}</StyledMenuItem>
      </Menu>
    </>
  );
};
